<template>
  <component
    :is="transitionType"
    :tag="tag"
    v-bind="$attrs"
    name="slide-y"
  >
    <slot/>
  </component>
</template>

<script>
export default {
  props: {
    group: {
      type: Boolean,
      default: false
    },
    tag: {
      type: String,
      default: "div"
    }
  },
  computed: {
    transitionType() {
      return this.group ? "transition-group" : "transition";
    }
  }
};
</script>

<style>
.slide-y-enter-active,
.slide-y-leave-active {
  transition: all 0.5s;
}
.slide-y-enter-active {
  transition-delay: 0.5s;
}
.slide-y-enter {
  transform: translateY(-105%);
}
.slide-y-leave-to {
  transform: translateY(-105%);
}
</style>
